import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { UserProvider } from '../../providers/user';
import {TeamappProvider} from "../../providers/teamapp";
import { ChatSinglePage } from '../chat-single/chat-single';
import { MarketplaceEditPage } from '../marketplace-edit/marketplace-edit';
/**
 * Generated class for the MarketplaceItemPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-marketplace-item',
  templateUrl: 'marketplace-item.html',
})
export class MarketplaceItemPage {
  title: string = 'Details';
  item: any;
  id: any;
  constructor(public teamappProvider: TeamappProvider, public userProvider: UserProvider, public navCtrl: NavController, public navParams: NavParams) {
    this.id = this.navParams.get('id');
    if(this.navParams.get('title')) {
        this.title = this.navParams.get('title');
    }
  }
    formatPrice(price: string) {
        return price.replace('.', ',');
    }
  startChat() {
      this.navCtrl.push(ChatSinglePage, { params: {
              name: this.item.from_surname,
              firstname: this.item.from_name,
              image: this.item.from_userimg,
              messages: [],
              target: this.item.chatkey
      } });
  }

  edit() {
      this.navCtrl.push(MarketplaceEditPage, {id: this.id, title: this.title});
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MarketplaceItemPage');
  }


  ionViewDidEnter() {
    this.loadData();
  }

  loadData() {
      this.teamappProvider.http_request('action=get_item&id='+this.id, 'marketplace', false, true).then(data => {
          this.item = data;
          console.log(data);
          if(this.item.valid != 1) {
              this.navCtrl.pop();
          }
      });
  }

  addToFavorite() {
      this.teamappProvider.http_request('action=add_item_to_favorit&id='+this.id, 'marketplace', false, true).then(data => {
          console.log(data);
            this.item.favorit = 1;
      });
  }

  removeFromFavorite() {
      this.teamappProvider.http_request('action=remove_item_from_favorit&id='+this.id, 'marketplace', false, true).then(data => {
            this.item.favorit = 0;
      });
  }

}



// WEBPACK FOOTER //
// ./src/pages/marketplace-item/marketplace-item.ts